module.exports = __webpack_public_path__ + "img/gold.ca5c8d42.png";